/**
 * VolumeLoadingPlaceholder - Loading State for Viewport Slots
 *
 * Calm placeholder shown while a series' volume loads — series + slot label and
 * a single C2 indeterminate sweep. No 0% ring / frame count: the old progress
 * ring sat at 0% for a long time and read as broken.
 */

import React from "react";

export interface VolumeLoadingPlaceholderProps {
  /** Series description to display */
  seriesDescription: string | null;
  /** Frames loaded so far (no longer rendered; kept for the caller's API). */
  loadedFrames: number;
  /** Total frames to load (no longer rendered; kept for the caller's API). */
  totalFrames: number;
  /** Slot label for context (e.g., "Axial Pre-Contrast") */
  slotLabel: string;
}

export const VolumeLoadingPlaceholder: React.FC<VolumeLoadingPlaceholderProps> = ({
  seriesDescription,
  slotLabel,
}) => {
  return (
    <div className="w-full h-full bg-black flex flex-col items-center justify-center gap-1.5">
      {seriesDescription && (
        <div className="text-fg-muted text-sm font-medium text-center px-4 max-w-full truncate">
          {seriesDescription}
        </div>
      )}

      {slotLabel && <div className="text-fg-dim text-xs">{slotLabel}</div>}

      <div className="mt-3 h-0.5 w-24 overflow-hidden">
        <div className="fetch-sweep h-full w-full" />
      </div>
    </div>
  );
};

export default VolumeLoadingPlaceholder;
